// mutations.js

export default {
    updateControllerList(state, controllers){
        state.controllerList = controllers
    },
};
